import React, { useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import ItemList from './item-list'
import { useCallback } from 'react'


const Item = props => {
    useStyles(classes)
    const { item, isViewMore, isSoldOut, onViewMore } = props


    const viewMoreHandle = useCallback(e => {
        if(isViewMore){
            onViewMore()
        }
    }, [isViewMore])

    return <div className={`${classes.Item} ${isSoldOut ? classes.SoldOutItem : ''}`}>
        <img src={item.imageUrl} />
        <span className={classes.Quantity}>
            <span>X{item.quantity}</span>
        </span>
        {
            item.isPreOrder && <span className={classes.PreOrder}>
                Pre order
            </span>
        }

        {
            (isSoldOut || isViewMore) && <div className={classes.ViewMore} onClick={viewMoreHandle}>
                {
                    isSoldOut ? <div className={classes.SoldOut}>
                        <div><FormattedMessage id="sold_out" defaultMessage="Sold Out" /></div>
                        {
                            isViewMore && <Iconfont className={classes.Icon}>&#xe74d;</Iconfont>
                        }
                    </div> : <Iconfont className={classes.Icon}>&#xe74d;</Iconfont>
                }
            </div>
        }
    </div>
}

const Items = props => {
    useStyles(classes)
    const { products, className, isSoldOut, onViewMore } = props
    return <div className={`${className} ${classes.Items}`}>
        {
            products?.map((p, index) => <Item onViewMore={onViewMore} isSoldOut={isSoldOut} isViewMore={index === 4} key={p.id} item={p} />)
        }
    </div>
}

export const InvalidGroup = props => {
    useStyles(classes)
    const { soldoutProducts } = props
    const [show, setShow] = useState(false)

    let itemCount = _.reduce((soldoutProducts || []), (result, product, index) => {
        return result + product.quantity
    }, 0)

    return <div className={`${classes.Container} ${classes.InvalidGroup}`}>
        <div className={classes.Hd}>
            <span className={classes.Title}>
                <FormattedMessage id="ivalid_items_title" defaultMessage="These items are temporarily out of stock." />
            </span>
            <span className={classes.SubTitle} onClick={e => setShow(true)}>
                <FormattedMessage id="count_items" defaultMessage="{total} Items" values={{ total: itemCount }} /> {'>'}
            </span>
        </div>
        <Items className={classes.Bd} isSoldOut products={soldoutProducts} />
        <ItemList show={show} onClose={e => setShow(false)} products={soldoutProducts} title={<FormattedMessage id="ivalid_items_title" defaultMessage="These items are temporarily out of stock." />} count={itemCount}/>
    </div>
}

export default props => {
    useStyles(classes)
    const { title, billingProducts, itemCount, parcelIndex, showIndex } = props
    const [show, setShow] = useState(false)
    return <div className={classes.Container}>
        <div className={classes.Hd}>
            <span className={`${classes.Title}`}>
                {
                    showIndex && <span className={classes.ParcelIndex}><FormattedMessage id="parcel" defaultMessage="Parcel" />{' '}{parcelIndex}{' - '}</span>
                }
                {title}
            </span>
            <span className={classes.SubTitle} onClick={e => setShow(true)}>
                <FormattedMessage id="count_items" defaultMessage="{total} Items" values={{ total: itemCount }} /> {'>'}
            </span>
        </div>
        <Items onViewMore={e => setShow(true)} className={classes.Bd} products={billingProducts} />
        <ItemList show={show} onClose={e => setShow(false)} products={billingProducts} title={title} count={itemCount}/>
    </div>
}